export enum TipoImpressaoEtiqueta {
  BOBINA_58 = 'BOBINA_58',
  BOBINA_80 = 'BOBINA_80',
  A4 = 'A4',
}

export interface EtiquetaItemFormDTO {
  tipoImpressao: { label: string; value: TipoImpressaoEtiqueta } | undefined;
  quantidade: number | null;
  quantidadeImpressa: number | null;
}
